"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactS3Uploader = _interopRequireDefault(require("react-s3-uploader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class InsertImageButton extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInsertDialog: false,
      isLoading: false,
      image: null
    };
  }
  handleToggleDialog(e) {
    this.setState({
      showInsertDialog: !this.state.showInsertDialog
    });
  }
  handleUploadProgress() {
    this.setState({
      isLoading: true
    });
  }
  handleUploadError() {
    this.setState({
      isLoading: false
    });
  }
  handleUploadFinish(e) {
    const handleUploadFinish = this.props.handleUploadFinish;
    const imgUrl = e.signedUrl.substring(0, e.signedUrl.indexOf('?'));
    this.setState({
      isLoading: false,
      image: imgUrl
    });
    handleUploadFinish(imgUrl);
  }
  handleOpenDialog() {
    _reactDom.default.findDOMNode(this.inputFile).click();
  }
  render() {
    const buttonClassName = this.props.buttonClassName;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
      className: buttonClassName,
      onClick: this.handleOpenDialog.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-image"
    })), /*#__PURE__*/_react.default.createElement(_reactS3Uploader.default, {
      signingUrl: "".concat(process.env.REACT_APP_DOMAIN_API_REST, "/uploads"),
      accept: "image/*",
      onProgress: this.handleUploadProgress.bind(this),
      onError: this.handleUploadError.bind(this),
      onFinish: this.handleUploadFinish.bind(this),
      ref: input => {
        this.inputFile = input;
      },
      style: {
        position: 'absolute',
        visibility: 'hidden'
      }
    }));
  }
}
var _default = exports.default = InsertImageButton;